import { PersonTwoTone, ShoppingCartTwoTone } from '@mui/icons-material';
import { Badge, Box, Button, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useAccount } from '../hooks/api/account';
import { useCart } from '../hooks/useCart';

export function LayoutWithCart() {
  const { t } = useTranslation();
  const { cart } = useCart();
  const { data: account, isLoading: accountLoading } = useAccount();
  const loc = useLocation();
  const [sp] = useSearchParams();
  const hideNav = sp.get('hideNav') === '1';

  return (
    <Box maxWidth="1400px" margin="auto">
      {!hideNav && (
        <Stack
          direction="row"
          justifyContent="flex-end"
          sx={{ pt: 1, pr: 1, mb: 1 }}
          spacing={1}
        >
          {accountLoading ? (
            <Button color="inherit" aria-label="account">
              <Skeleton variant="text" width={100} />
            </Button>
          ) : account ? (
            <Link to="/account" style={{ color: 'inherit' }}>
              <Button
                color="inherit"
                aria-label="account"
                startIcon={<PersonTwoTone />}
              >
                {account.individual?.firstName} {account.individual?.lastName}
              </Button>
            </Link>
          ) : (
            <Link
              to={`/login?next=${loc.pathname}`}
              style={{ color: 'inherit' }}
            >
              <Button
                color="inherit"
                aria-label="login"
                startIcon={<PersonTwoTone />}
              >
                {t('layoutWithCart.login')}
              </Button>
            </Link>
          )}

          <Link to="/cart" style={{ color: 'inherit' }}>
            <Button
              color="inherit"
              aria-label="cart"
              startIcon={
                <Badge
                  badgeContent={cart.items.length}
                  showZero
                  color="primary"
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -3,
                      top: 13,
                      border: (t) => `2px solid ${t.palette.background.paper}`,
                      padding: '0 4px',
                    },
                  }}
                >
                  <ShoppingCartTwoTone />
                </Badge>
              }
            >
              <Box component="span" sx={{ ml: 1 }}>
                {t('layoutWithCart.cart')}
              </Box>
            </Button>
          </Link>
        </Stack>
      )}
      <Outlet />
    </Box>
  );
}
